import { Link } from "react-router-dom";

import { PageShell } from "../components/PageShell.js";
import { Seo } from "../components/Seo.js";

export function TermsOfService() {
  return (
    <PageShell>
      <Seo
        title="Terms of Service · JivaSeva"
        description="The terms governing your use of the JivaSeva website."
        path="/terms-of-service"
      />
      <h1 className="page-heading">Terms of Service</h1>
      <p className="manifesto">
        <strong>Last Updated:</strong> July 7, 2026
      </p>

      <h2 className="section-heading">Acceptance of These Terms</h2>
      <p className="manifesto">Welcome to JivaSeva.</p>
      <p className="manifesto">
        By accessing or using this website, you agree to these Terms of Service.
        If you do not agree with these Terms, please do not use the website.
      </p>

      <h2 className="section-heading">About JivaSeva</h2>
      <p className="manifesto">
        JivaSeva is an independent, volunteer-driven, not-for-profit initiative
        dedicated to promoting selfless service and compassionate action.
      </p>
      <p className="manifesto">
        The information provided on this website is intended for general
        informational purposes and to share the mission, services, and activities
        of JivaSeva.
      </p>

      <h2 className="section-heading">Use of the Website</h2>
      <p className="manifesto">
        You agree to use this website lawfully and respectfully.
      </p>
      <p className="manifesto">You agree not to:</p>
      <ul className="bullet-list">
        <li>Use the website for any unlawful or fraudulent purpose.</li>
        <li>
          Attempt to interfere with the operation or security of the website.
        </li>
        <li>Attempt to gain unauthorized access to any systems or data.</li>
        <li>Introduce malicious software or harmful code.</li>
        <li>Misrepresent your identity when communicating with JivaSeva.</li>
      </ul>

      <h2 className="section-heading">Intellectual Property</h2>
      <p className="manifesto">
        Unless otherwise stated, the content of this website—including text,
        graphics, logos, images, and other materials—is the property of JivaSeva
        or is used with appropriate permission.
      </p>
      <p className="manifesto">
        You may view, download, and share content for personal, educational, or
        non-commercial purposes provided that the content is not modified and
        appropriate attribution is maintained.
      </p>
      <p className="manifesto">
        Commercial use or redistribution requires prior written permission.
      </p>

      <h2 className="section-heading">Third-Party Links</h2>
      <p className="manifesto">
        This website may contain links to third-party websites for your
        convenience. JivaSeva does not control or endorse the content, services,
        or privacy practices of those external websites and is not responsible for
        their availability or accuracy.
      </p>

      <h2 className="section-heading">Disclaimer</h2>
      <p className="manifesto">
        While we strive to keep the information on this website accurate and up to
        date, the website and its contents are provided on an "as available" basis
        without warranties of any kind, either express or implied.
      </p>
      <p className="manifesto">
        JivaSeva does not guarantee that the website will always be available,
        uninterrupted, secure, or free from errors.
      </p>

      <h2 className="section-heading">Limitation of Liability</h2>
      <p className="manifesto">
        To the fullest extent permitted by applicable law, JivaSeva and its
        volunteers shall not be liable for any direct, indirect, incidental,
        consequential, or special damages arising from your use of, or inability
        to use, this website.
      </p>

      <h2 className="section-heading">Future Services</h2>
      <p className="manifesto">
        As JivaSeva grows, additional services, applications, volunteer programs,
        or community initiatives may be introduced. Those services may be governed
        by additional terms, privacy notices, or participation guidelines, which
        will be provided where applicable.
      </p>

      <h2 className="section-heading">Changes to These Terms</h2>
      <p className="manifesto">
        We may update these Terms of Service from time to time to reflect changes
        to the website, our services, or applicable law. Continued use of the
        website after changes are posted constitutes acceptance of the revised
        Terms.
      </p>

      <h2 className="section-heading">Contact Us</h2>
      <p className="manifesto">
        If you have questions regarding these Terms of Service, please contact us
        through the{" "}
        <Link to="/contact" className="inline-link">
          Contact page
        </Link>{" "}
        on this website or by email at{" "}
        <a className="inline-link" href="mailto:support@jivaseva.com">
          support@jivaseva.com
        </a>
        .
      </p>
    </PageShell>
  );
}
